import { useState } from 'react';
import { Plus } from 'lucide-react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';

interface ParticipantFormProps {
  onSubmit: (name: string) => void;
  placeholder?: string;
}

export function ParticipantForm({
  onSubmit,
  placeholder = 'Nombre del participante',
}: ParticipantFormProps) {
  const [name, setName] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (name.trim()) {
      onSubmit(name.trim());
      setName('');
    }
  };

  return (
    <form onSubmit={handleSubmit} className="flex gap-2">
      <Input
        value={name}
        onChange={(e) => setName(e.target.value)}
        placeholder={placeholder}
        className="flex-1"
      />
      <Button type="submit" size="icon" disabled={!name.trim()}>
        <Plus className="h-4 w-4" />
      </Button>
    </form>
  );
}
